var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      class: _vm.question.getSelectBaseRootCss(),
      attrs: {
        role: _vm.question.a11y_input_ariaRole,
        "aria-required": _vm.question.a11y_input_ariaRequired,
        "aria-label": _vm.question.a11y_input_ariaLabel,
        "aria-labelledby": _vm.question.a11y_input_ariaLabelledBy,
        "aria-describedby": _vm.question.a11y_input_ariaDescribedBy,
        "aria-invalid": _vm.question.a11y_input_ariaInvalid,
        "aria-errormessage": _vm.question.a11y_input_ariaErrormessage,
      },
    },
    [
      _vm._l(_vm.question.bodyItems, function (item) {
        return !_vm.question.hasColumns && !_vm.question.blockedRow
          ? _c(_vm.question.itemComponent, {
              key: item.value,
              tag: "component",
              attrs: { question: _vm.question, item: item },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.question.blockedRow
        ? _c(
            "div",
            { class: _vm.question.cssClasses.rootRow },
            _vm._l(_vm.question.dataChoices, function (item) {
              return !_vm.question.hasColumns && _vm.question.blockedRow
                ? _c(_vm.question.itemComponent, {
                    key: item.value,
                    tag: "component",
                    attrs: { question: _vm.question, item: item },
                  })
                : _vm._e()
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.question.hasColumns
        ? _c(
            "div",
            { class: _vm.question.cssClasses.rootMultiColumn },
            _vm._l(_vm.question.columns, function (column, colIndex) {
              return _vm.question.hasColumns
                ? _c(
                    "div",
                    {
                      key: colIndex,
                      class: _vm.question.getColumnClass(),
                      attrs: { role: "presentation" },
                    },
                    _vm._l(column, function (item) {
                      return _c(_vm.question.itemComponent, {
                        key: item.value,
                        tag: "component",
                        attrs: { question: _vm.question, item: item },
                      })
                    }),
                    1
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.question.footItems, function (item) {
        return _vm.question.hasFootItems
          ? _c(_vm.question.itemComponent, {
              key: item.value,
              tag: "component",
              attrs: { question: _vm.question, item: item },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.question.renderedValue && _vm.question.isOtherSelected
        ? _c("survey-other-choice", { attrs: { question: _vm.question } })
        : _vm._e(),
      _vm._v(" "),
      _vm.question.showClearButtonInContent
        ? _c("div", [
            _c("input", {
              class: _vm.question.cssClasses.clearButton,
              attrs: { type: "button", value: _vm.question.clearButtonCaption },
              on: {
                click: function () {
                  _vm.question.clearValue(true)
                },
              },
            }),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }